import RemarksDialog from "./remarksDialog.container";

export default RemarksDialog;